import moment from "moment";
import { action } from "mobx";

import { dispatchEvent, EventMaker } from "../../trigger/index";

let handlers = {};

const doHandlers = action("doClockHandlers", () => {
  const now = moment();
  Object.values(handlers).forEach(handler => handler(now));
});
setInterval(doHandlers, 1000);

export const clock = (params, id, cb) => {
  handlers[id] = now =>
    cb({
      hour: { type: "number", value: now.format("HH") },
      h: { type: "number", value: now.format("h") },
      meridiem: { type: "text", value: now.format("a") },
      minute: { type: "number", value: now.format("mm") },
      second: { type: "number", value: now.format("ss") }
    });
};

export const timeFormat = undefined; //"HH:mm:ss";

export const countdown = (params, id, cb) => {
  handlers[id] = now => {
    const target = moment(params.target, timeFormat);
    const started = moment(params.startAt, timeFormat);
    const remaining = target.diff(now);
    if (1000 * Math.ceil(remaining / 1000) - 1000 === 0) {
      dispatchEvent(EventMaker.countdownFinished(id));
    }
    const elapsed = now.diff(started);
    const duration = moment.duration(remaining);
    const max0 = c => ("0" + Math.max(0, c)).slice(-2);
    const total = target.diff(started);
    cb({
      hour: { type: "number", value: max0(Math.floor(duration.asHours())) },
      minute: { type: "number", value: max0(duration.minutes()) },
      second: { type: "number", value: max0(duration.seconds()) },
      progress: {
        type: "progress",
        value: Math.round(Math.min(100, elapsed * 100 / total))
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/clock.js